import classNames from 'classnames';

export function tabClasses({
  active,
}: {
  active?: boolean;
}) {
  return classNames('font-medium py-2 inline-block border-b-[3px]', active ? 'text-slate-800 hover:text-slate-800 border-blue-600' : 'border-transparent text-slate-500 hover:text-slate-600 hover:border-slate-250');
}
